import Footer from './Footer.react'

export default Footer
